import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TFact {
  id: number;
  name: string;
  description: string;
  sqlExpression: string;
  dataType: string;
}

export interface IFact extends TFact {}

export const FactDataTypes = [
  {
    id: "DATUM",
    name: "DATUM"
  },
  {
    id: "BROJ",
    name: "BROJ"
  },
  {
    id: "TEKST",
    name: "TEKST"
  }
];

const Fact = Model(
  (model: TFact): IFact => {
    const _fact: TFact = Object.assign({}, model);

    let create = (fact: IFact): IFact => {
      let obj = ValidatableObject(fact);
      return obj;
    };

    let fact = {
      get id() {
        return _fact.id;
      },
      set id(value) {
        _fact.id = value;
      },
      get name() {
        return _fact.name;
      },
      set name(value) {
        _fact.name = value;
      },
      get description() {
        return _fact.description;
      },
      set description(value) {
        _fact.description = value;
      },
      get dataType() {
        return _fact.dataType;
      },
      set dataType(value) {
        _fact.dataType = value;
      },
      get sqlExpression() {
        return _fact.sqlExpression;
      },
      set sqlExpression(value) {
        _fact.sqlExpression = value;
      }
    };

    return create(fact);
  }
);

export default Fact;
